/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable quotes */
/* eslint-disable @typescript-eslint/no-unused-vars */
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';
import JsBarcode from 'jsbarcode';
import type { TDocumentDefinitions, Content } from 'pdfmake/interfaces';

interface Iitens {
  qtds: number;
  un: string;
  preco: number;
  subtotal: number;
  total: number;
  referencia?: string;
  filtro: string;
  descricao: string;
}

interface IgetImpressao {
  idmov: string;
  dataoperacao: string;
  numero: string;
  total: number;
  vprod: number;
  desconto: number;
  acrescimo: number;
  cidade?: string;
  uf?: string;
  vendedor?: string;
  celular?: string;
  cep?: string;
  nome?: string;
  endereco?: string;
  obs?: string;
  itens: Iitens[];
}

async function PDFVenda02(dados: IgetImpressao): Promise<Blob> {
  pdfMake.fonts = {
    Roboto: {
      normal: 'Roboto-Regular.ttf',
      bold: 'Roboto-Medium.ttf',
      italics: 'Roboto-Italic.ttf',
      bolditalics: 'Roboto-MediumItalic.ttf',
    },
  };

  if (pdfFonts?.pdfMake?.vfs) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
  }

  const gerarCodigoBarras = (texto: string) => {
    const canvas = document.createElement('canvas');
    JsBarcode(canvas, texto, {
      format: 'CODE128',
      height: 40,
      displayValue: false,
    });
    return canvas.toDataURL('image/png');
  };

  const codigoBarras = gerarCodigoBarras(dados.idmov);
  const LIMITE_ITENS = 8;
  const paginas: Iitens[][] = [];

  for (let i = 0; i < dados.itens.length; i += LIMITE_ITENS) {
    paginas.push(dados.itens.slice(i, i + LIMITE_ITENS));
  }

  const ALTURA_FIXA_ITENS = 150;
  const content: Content[] = [];

  paginas.forEach((itensPagina, index) => {
    const linhasItens = itensPagina.map((item) => [
      { text: item.qtds.toFixed(3), fontSize: 9, alignment: 'right' },
      { text: item.descricao || '-', fontSize: 9 },
      { text: item.referencia || '-', fontSize: 9 },
      { text: item.un || 'UN', fontSize: 9, alignment: 'center' },
      {
        text: item.preco.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }),
        fontSize: 9,
        alignment: 'right',
      },
      {
        text: item.subtotal.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }),
        fontSize: 9,
        alignment: 'right',
      },
    ]);

    content.push({
      table: {
        widths: ['*'],
        heights: [ALTURA_FIXA_ITENS],
        body: [
          [
            {
              table: {
                headerRows: 1,
                widths: [30, '*', 70, 30, 65, 65],
                body: [
                  [
                    { text: 'QTD', bold: true, fontSize: 9 },
                    { text: 'DESCRIÇÃO', bold: true, fontSize: 9 },
                    { text: 'REF.', bold: true, fontSize: 9 },
                    { text: 'UN', bold: true, fontSize: 9 },
                    { text: 'VL UNIT.', bold: true, fontSize: 9, alignment: 'right' },
                    { text: 'TOTAL', bold: true, fontSize: 9, alignment: 'right' },
                  ],
                  ...linhasItens,
                ],
              },
              layout: 'lightHorizontalLines',
            },
          ],
        ],
      },
      layout: 'noBorders',
    });

    content.push({
      canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 560,
          y2: 0,
          lineWidth: 0.6,
          dash: { length: 4 },
        },
      ],
      margin: [0, -15, 0, 6],
    });

    content.push({
      columns: [
        {
          text: `Valor: ${dados.vprod.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })}`,
          fontSize: 10,
        },
        {
          text: `Acrésc.: ${(dados.acrescimo || 0).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })}`,
          fontSize: 10,
          alignment: 'center',
        },
        {
          text: `Desc.: ${(dados.desconto || 0).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })}`,
          fontSize: 10,
          alignment: 'center',
        },
        {
          text: `Líquido: ${dados.total.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })}`,
          fontSize: 10,
          bold: true,
          alignment: 'right',
        },
      ],
    });

    content.push({
      canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 560,
          y2: 0,
          lineWidth: 0.6,
          dash: { length: 4 },
        },
      ],
      margin: [0, 10, 0, 6],
    });

    content.push({
      text: `Obs: ${dados.obs || ''}`,
      fontSize: 9,
      margin: [0, 6, 0, 14],
    });

    content.push({
      margin: [0, 5, 0, 12],
      stack: [
        {
          canvas: [
            {
              type: 'line',
              x1: (560 - 200) / 2,
              y1: 0,
              x2: (560 + 200) / 2,
              y2: 0,
              lineWidth: 0.7,
            },
          ],
        },
        {
          text: `${'Assinatura do Cliente'}`,
          fontSize: 9,
          italics: true,
          alignment: 'center',
          margin: [0, 4, 0, 0],
        },
      ],
    });

    content.push({
      image: codigoBarras,
      width: 200,
      alignment: 'center',
      margin: [0, -8, 0, 0],
    });

    content.push({
      text: `Página ${index + 1} de ${paginas.length}`,
      fontSize: 9,
      alignment: 'right',
      margin: [0, -40, 0, 0],
    });

    if (index < paginas.length - 1) {
      content.push({ text: '', pageBreak: 'after' });
    }
  });

  const documentDefinition: TDocumentDefinitions = {
    pageSize: 'A4',
    pageOrientation: 'portrait',
    pageMargins: [20, 155, 20, 40],
    header: () => ({
      margin: [20, 105, 20, 0],
      table: {
        widths: ['*', '*'],
        body: [
          [
            {
              text: `Cliente: ${dados.nome || '-'}`,
              fontSize: 10,
            },
            {
              text: `Data: ${moment(dados.dataoperacao).format('DD/MM/YYYY [às] HH:mm:ss')}`,
              fontSize: 10,
              alignment: 'right',
              bold: true,
            },
          ],
          [
            {
              text: `Endereço: ${dados.endereco || '-'}`,
              fontSize: 10,
            },
            {
              text: `Cel: ${dados.celular || '-'}`,
              fontSize: 10,
              alignment: 'right',
            },
          ],
          [
            {
              text: `Cidade: ${dados.cidade || '-'} / ${dados.uf || ''}  CEP: ${dados.cep || '-'}`,
              fontSize: 10,
              alignment: 'left',
            },
            {
              text: `Nº: ${dados.numero || '-'}`,
              fontSize: 10,
              alignment: 'right',
            },
          ],
        ],
      },
      layout: 'noBorders',
    }),
    content,
    defaultStyle: {
      font: 'Roboto',
    },
  };

  // 🔥 MUDANÇA PRINCIPAL: Retornar Blob em vez de abrir diretamente
  return new Promise((resolve, reject) => {
    try {
      const pdfDocGenerator = pdfMake.createPdf(documentDefinition);

      pdfDocGenerator.getBlob((blob) => {
        resolve(blob);
      });
    } catch (error) {
      reject(error);
    }
  });
}

export default PDFVenda02;